'use es6';

import { useCallback } from 'react';
import { EDITOR_TYPES } from 'reporting-data/tsTypes/editorTypes';
import { useEditorComponents } from 'reporting-enablement/components/reportEditors/common/useEditorComponents';
import { deriveChartMetricsFromReport } from '../../constants/sub-app/contextDefaults';
import { getSpecificEditorSchema, isChartReport, isSnowflakeReport, isTableReport } from '../../utils/salesAnalyticsHelpers';
import usageTracker from '../../utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
const MultiMetricControl = ({
  report,
  updateContext
}) => {
  const metricEditorSchema = getSpecificEditorSchema(report, EDITOR_TYPES.METRIC);
  const handleChange = useCallback(updatedReport => {
    const metricKeys = deriveChartMetricsFromReport(updatedReport);
    updateContext({
      chartMetrics: metricKeys
    }, report);
  }, [report, updateContext]);
  const EditorComponents = useEditorComponents(report, [metricEditorSchema]);
  if (EditorComponents.length === 0) {
    return null;
  }
  const EditorComponent = EditorComponents[0];
  return /*#__PURE__*/_jsx(EditorComponent, {
    appUsageTracker: usageTracker,
    onChange: handleChange,
    report: report
  });
};
MultiMetricControl.isUsableForReport = ({
  report
}) => (isChartReport(report) || isTableReport(report)) && !isSnowflakeReport(report) && !!getSpecificEditorSchema(report, EDITOR_TYPES.METRIC);
export default MultiMetricControl;